const uuidv4 = require('uuid/v4')
const shortid = require('shortid')

shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')

export const MakeIdCharacterTypes = {
  AphlaLower: 'AphlaLower',
  AphlaUpper: 'AphlaUpper',
  Numeric: 'Number',
  Mixed: 'Mixed'
}

export const IdHelper = {
  uuId: () => {
    return uuidv4()
  },
  shortId: () => {
    return shortid.generate()
  },
  makeId: (length, type = MakeIdCharacterTypes.Mixed) => {
    var result = ''
    let characters = ''
    switch (type) {
      case MakeIdCharacterTypes.AphlaLower:
        characters = 'abcdefghijklmnopqrstuvwxyz'
        break
      case MakeIdCharacterTypes.AphlaUpper:
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        break
      case MakeIdCharacterTypes.Numeric:
        characters = '0123456789'
        break
      case MakeIdCharacterTypes.Mixed:
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        break
    }
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }
}

export default IdHelper
